import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import axios from "@app/lib/axios";
import { format, addDays, addMonths, isSameMonth } from "date-fns";

import ReactEcharts from "echarts-for-react";

import * as Constant from "@app/Constant.js";

import CommonHorizontalBarChart from "@app/components/CommonHorizontalBarChart/index";
import CommonVerticalBarChart from "@app/components/CommonVerticalBarChart/index";

const ContentNursery = forwardRef(
    ({ isRoleBranch, statPeriod, branchId, branchName, nurseryId, nurseryName, classId, className, updateViewSubOption, onViewSubOptionSelected, statAll, updateCategoryStat }, ref) => {
        const [stat, setStat] = useState(false);
        const [statClass, setStatClass] = useState(false);
        const [statOs, setStatOs] = useState(false);
        const [statContent, setStatContent] = useState(false);

        useImperativeHandle(ref, () => ({
            getExcelData(callback) {
                if (stat && stat.length > 0) {
                    const isClassTotal = classId == "-";
                    const excelData = {
                        fileName: `플라잉클래스_${isClassTotal ? "원" : "클래스"}통계`,
                        sheets: isClassTotal
                            ? [
                                  {
                                      name: "접속",
                                      title: `${isRoleBranch ? "" : branchName + " -"} ${nurseryName} 접속 통계`,
                                      columnTitle: ["", "앱", "웹"],
                                      data: stat ? stat.map((s) => [s.statDate, s.osAndroid || 0, s.osWeb || 0]) : [],
                                  },
                                  {
                                      name: "콘텐츠",
                                      title: `${isRoleBranch ? "" : branchName + " -"} ${nurseryName} 콘텐츠 통계`,
                                      columnTitle: ["", "교실영어 실행 수", "스페셜 실행 수"],
                                      data: stat ? stat.map((s) => [s.statDate, s.playCountClassSum || 0, s.playCountSpecialSum || 0]) : [],
                                  },
                                  {
                                      name: "반별",
                                      title: `${isRoleBranch ? "" : branchName + " -"} ${nurseryName} 반별 콘텐츠 통계`,
                                      columnTitle: ["반", "교실영어 실행 수", "스페셜 실행 수"],
                                      data: statClass ? statClass.map((s) => [s.name, s.playCountClassSum || 0, s.playCountSpecialSum || 0]) : [],
                                  },
                              ]
                            : [
                                  {
                                      name: "접속",
                                      title: `${isRoleBranch ? "" : branchName + " -"} ${nurseryName} - ${className} 접속 통계`,
                                      columnTitle: ["", "앱", "웹"],
                                      data: stat ? stat.map((s) => [s.statDate, s.osAndroid || 0, s.osWeb || 0]) : [],
                                  },
                                  {
                                      name: "콘텐츠",
                                      title: `${isRoleBranch ? "" : branchName + " -"} ${nurseryName} - ${className} 콘텐츠 통계`,
                                      columnTitle: ["", "교실영어 실행 수", "스페셜 실행 수"],
                                      data: stat ? stat.map((s) => [s.statDate, s.playCountClassSum || 0, s.playCountSpecialSum || 0]) : [],
                                  },
                              ],
                    };
                    callback(null, excelData);
                }
            },
        }));

        const initState = () => {
            setStat(null);
            setStatOs(null);
            setStatContent(null);
        };

        const getStat = () => {
            const isClassTotal = classId == "-";      
            if (isClassTotal) {
                if (statAll) {
                    applyData(statAll);
                    return;
                } else {
                    updateCategoryStat(false);
                }
            }

            initState();

            var url = isClassTotal
                ? `/api/flyeng_stat/new/class/activity/branch/${branchId}/nursery/${nurseryId}`
                : `/api/flyeng_stat/new/class/activity/branch/${branchId}/nursery/${nurseryId}/class/${classId}`;

            axios({
                method: "POST",
                url: Constant.API_DOMAIN + url,
                data: {
                    start: statPeriod.startDate,
                    end: statPeriod.endDate,
                    periodType: statPeriod.type,
                },
            })
                .then((result) => {
                    if (result.data.code === 200) {
                        var data = result.data;
                        if (isClassTotal) {
                            updateCategoryStat(data);
                        } else {
                            applyData(data);
                        }
                    } else {
                        alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        };

        const applyData = (data) => {
            if (!data) {
                initState();
                return;
            }
            const isClassTotal = classId == "-";
            var stat = [];
            var classes = data.classes;
            var statOs = [
                { id: "android", name: "앱", value: 0 },
                { id: "web", name: "웹", value: 0 },
            ];
            var statContent = [
                { id: 0, name: "교실영어", value: 0 },
                { id: 1, name: "스페셜", value: 0 },
            ];
            if (classes) {
                classes.forEach((c) => {
                    c.playCountClass = 0;
                    c.playCountSpecial = 0;
                    c.playCountClassSum = 0;
                    c.playCountSpecialSum = 0;
                    c.osAndroid = 0;
                    c.osIos = 0;
                    c.osWeb = 0;
                });
            }

            let start = new Date(statPeriod.startDate);
            let day = new Date(statPeriod.startDate);
            for (let i = 0; i < 99; i++) {
                const statDate = format(day, statPeriod.type === "year" ? "yyyy-MM" : "yyyy-MM-dd");
                const statDateStr = format(day, statPeriod.type === "year" ? "yyyy-MM" : "MM-dd");
                const statDateList = data.data.filter((s) => s.statDate === statDate);
                let statDay = { statDate: statDateStr, playCountClassSum: 0, playCountSpecialSum: 0, osAndroid: 0, osIos: 0, osWeb: 0 };

                statDateList.forEach((s) => {
                    if (isClassTotal) {
                        var sClass = classes ? classes.find((c) => c.id == s.id) : null;
                        if (sClass) {
                            sClass.playCountClass += s.playCountClass || 0;
                            sClass.playCountSpecial += s.playCountSpecial || 0;
                            sClass.playCountClassSum += s.playCountClassSum || 0;
                            sClass.playCountSpecialSum += s.playCountSpecialSum || 0;
                            sClass.osAndroid += s.osAndroid || 0;
                            sClass.osIos += s.osIos || 0;
                            sClass.osWeb += s.osWeb || 0;
                            s.name = sClass.name;
                        }
                    }
                    statDay.playCountClassSum += s.playCountClassSum ? s.playCountClassSum : 0;
                    statDay.playCountSpecialSum += s.playCountSpecialSum ? s.playCountSpecialSum : 0;
                    statDay.osAndroid += s.osAndroid || 0;
                    statDay.osIos += s.osIos || 0;
                    statDay.osWeb += s.osWeb || 0;

                    statOs[0].value += s.osAndroid ? s.osAndroid : 0;
                    statOs[1].value += s.osWeb ? s.osWeb : 0;
                    statContent[0].value += s.playCountClassSum ? s.playCountClassSum : 0;
                    statContent[1].value += s.playCountSpecialSum ? s.playCountSpecialSum : 0;
                });

                stat.push(statDay);

                if (statPeriod.type === "week") {
                    day = addDays(day, 1);
                    if (i >= 6) break;
                } else if (statPeriod.type === "month") {
                    day = addDays(day, 1);
                    if (!isSameMonth(day, start)) break;
                } else {
                    // year
                    day = addMonths(day, 1);
                    if (i > 11) break;
                }
            }
            setStat(stat);
            setStatClass(classes);
            setStatOs(statOs);
            setStatContent(statContent);
            if (isClassTotal && updateViewSubOption) {
                console.debug(data, classes);
                updateViewSubOption([{ name: "전체", id: "-" }].concat(classes));
            }
        };

        useEffect(() => {
            getStat();
            return () => {};
        }, [statPeriod, classId]);

        useEffect(() => {
            applyData(statAll);
            return () => {};
        }, [statAll]);

        if (!stat) {
            return (
                <div className="w-100">
                    <div className="row">
                        <div
                            className="col"
                            style={{
                                height: "500px",
                                textAlign: "center",
                                paddingTop: `100px`,
                            }}
                        >
                            <span className="dashboard-spinner spinner-xxl"></span>
                        </div>
                    </div>
                </div>
            );
        } else {
            const isClassTotal = classId == "-";
            const classTotalChartOption = {
                xAxis: {
                    name: "건",
                    series: [
                        { name: "교실영어", field: "playCountClassSum", stack: "base", option: { itemStyle: { color: "#3574dc" } } },
                        { name: "스페셜", field: "playCountSpecialSum", stack: "base", option: { itemStyle: { color: "#b293ee" } } },
                    ],
                },
                stacks: [{ stack: "base", showSum: false, showSumTooltip: true, showPercent: true }],
                yAxis: { field: "name" },
                showLegend: true,
                showSum: true,
                sort: false,
                grid: {
                    top: "10%",
                    left: "10%",
                    bottom: "10%",
                },
                legend: {
                    x: "right",
                },
            };
            const classChartOption = {
                xAxis: { field: "statDate" },
                yAxis: {
                    name: "사용량(건)",
                    series: [
                        { name: "교실영어", field: "playCountClassSum", stack: "base", option: { itemStyle: { color: "#3574dc" } } },
                        { name: "스페셜", field: "playCountSpecialSum", stack: "base", option: { itemStyle: { color: "#b293ee" } } },
                    ],
                },
                showLegend: true,
                grid: {
                    top: "10%",
                    left: "10%",
                    bottom: "10%",
                },
                legend: {
                    x: "right",
                },
            };
            const optionOs = {
                tooltip: {
                    trigger: "item",
                    formatter: (param) => {
                        return param.data ? param.data.name + " : " + param.data.value.toLocaleString() + " (" + Math.ceil(param.percent) + "%)" : "";
                    },
                },
                series: {
                    type: "pie",
                    data: statOs,
                    radius: "95%",
                    center: ["35%", "50%"],
                    labelLine: {
                        show: false,
                    },
                    label: {
                        show: false,
                        position: "center",
                    },
                },
                color: ["#60d7c5", "#b9ed4a"],
                showLegend: true,
                legend: {
                    x: "right",
                    y: "middle",
                    orient: "vertical",
                    align: "left",
                    formatter: (name) => {
                        const s = statOs.find((s) => s.name === name);
                        if (s) {
                            return `${name} - ${s.value}`;
                        }
                        return name;
                    },
                },
            };
            const optionContent = {
                tooltip: {
                    trigger: "item",
                    formatter: (param) => {
                        return param.data ? param.data.name + " : " + param.data.value.toLocaleString() + " (" + Math.ceil(param.percent) + "%)" : "";
                    },
                },
                series: [
                    {
                        type: "pie",
                        data: statContent,
                        radius: ["0%", "95%"],
                        center: ["35%", "50%"],
                        labelLine: {
                            show: false,
                        },
                        label: {
                            show: false,
                            position: "center",
                        },
                    },
                ],
                color: ["#3574dc", "#b293ee", "#1773DC", "#B271EE"],
                showLegend: true,
                legend: {
                    x: "right",
                    y: "middle",
                    orient: "vertical",
                    align: "left",
                    formatter: (name) => {
                        const s = statContent.find((s) => s.name === name);
                        if (s) {
                            return `${name} - ${s.value}`;
                        }
                        return name;
                    },
                },
            };
            const onClassSelect = (e) => {
                if (onViewSubOptionSelected) {
                    onViewSubOptionSelected(e.id);
                }
            };
            return (
                <div className="w-100">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="card">
                                <div className={`card-header stat-content-card-title`}>접속 경로</div>
                                <div className="card-body" style={{ height: "auto" }}>
                                    <div>
                                        {/* <PieChart data={statOs} height={150} /> */}
                                        <ReactEcharts theme="macarons" option={optionOs} style={{ height: `150px` }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="card">
                                <div className={`card-header stat-content-card-title`}>콘텐츠 사용량</div>
                                <div className="card-body" style={{ height: "auto" }}>
                                    <div>
                                        {/* <PieChart data={statContent} height={150} /> */}
                                        <ReactEcharts theme="macarons" option={optionContent} style={{ height: `150px` }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {isClassTotal && (
                        <div className="row">
                            <div className="col">
                                <div
                                    className="card"
                                    style={{
                                        height: statClass && statClass.length > 0 ? statClass.length * 30 + 200 : 200,
                                    }}
                                >
                                    <div className={`card-header stat-content-card-title`}>반별 사용량</div>
                                    <div className="card-body">
                                        <CommonVerticalBarChart chartData={statClass} chartOption={classTotalChartOption} onSelect={onClassSelect.bind(this)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="row">
                        <div className="col">
                            <div className="card" style={{ height: "400px" }}>
                                <div className={`card-header stat-content-card-title`}>기간별 사용량</div>
                                <div className="card-body">
                                    <CommonHorizontalBarChart chartData={stat} chartOption={classChartOption} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
);

export default ContentNursery;
